import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Form,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";
import { MdOutlineRefresh } from "react-icons/md";
import toast from "react-hot-toast";

const Quotations = () => {
  const [quotations, setQuotations] = useState([]);
  const [refreshData, setRefreshData] = useState(false);
  const navigate = useNavigate();

  const [total, setTotal] = useState(0); // For total quotations
  const [page, setPage] = useState(1); // Current page
  const [limit] = useState(10); // Limit of quotations per page

  const totalPages = Math.ceil(total / limit); // Calculate total pages

  const maxPagesToShow = 5; // Maximum number of pages to show at a time
  const startPage = Math.max(1, page - Math.floor(maxPagesToShow / 2));
  const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

  const [searchByName, setSearchByName] = useState("");
  const [searchByEmail, setSearchByEmail] = useState("");

  useEffect(() => {
    // Get token from local storage
    const token = localStorage.getItem("token");

    fetch(
      `https://api.pegasuschauffeurdrive.com/api/quotation?page=${page}&limit=${limit}&fullName=${searchByName}&email=${searchByEmail}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          // Handle HTTP errors
          throw new Error("Network response was not ok");
        }
        if (response.status === 204) {
          // Handle no content response
          return { quotations: [], total: 0 };
        }
        return response.json();
      })
      .then((response) => {
        if (response.errors) {
          console.error(response.errors);
          return;
        }
        setQuotations(response.quotations);
        setTotal(response.total);
      })
      .catch((error) => {
        console.error("Error fetching quotations:", error);
        toast.error("Failed to fetch quotations");
      });
    setRefreshData(false);
  }, [refreshData, page, limit, searchByName, searchByEmail]);

  // Handle page change
  const handlePageChange = (newPage) => {
    setPage(newPage);
    setRefreshData(true); // Refresh data on page change
  };

  const handleSearchByNameChange = (event) => {
    setSearchByName(event.target.value);
  };

  const handleSearchByEmailChange = (event) => {
    setSearchByEmail(event.target.value);
  };

  const handleSearchSubmit = () => {
    setPage(1);
    setRefreshData(true);
  };

  const handleSearchReset = () => {
    setSearchByName("");
    setSearchByEmail("");
    setPage(1);
    setRefreshData(true);
  };

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   return new Intl.DateTimeFormat('en-US', {
  //     year: 'numeric', 
  //     month: 'short', 
  //     day: 'numeric',
  //     hour: '2-digit',
  //     minute: '2-digit'
  //   }).format(date);
  // };

  return (
    <div>
      <div style={{ height: "52px" }}>
        <h1 className="fw-bold" style={{ color: "#fff" }}>
          Quotations
        </h1>
      </div>
      <hr style={{ color: "#fff", borderTop: "3px solid" }} />
      <div className="d-flex justify-content-between my-3">
        <Form>
          <Row className="row-cols-lg-auto g-3 align-items-center">
            <Col>
              <Input
                id="searchByName"
                name="searchByName"
                placeholder="Search by Name"
                type="text"
                value={searchByName}
                onChange={handleSearchByNameChange}
              />
            </Col>
            <Col>
              <Input
                id="searchByEmail"
                name="searchByEmail"
                placeholder="Search by Email"
                type="text"
                value={searchByEmail}
                onChange={handleSearchByEmailChange}
              />
            </Col>
            <Col>
              <Button
                style={{
                  background: "none",
                  color: "#fff",
                  border: "2px solid #fff",
                }}
                onClick={handleSearchSubmit}
              >
                Search
              </Button>
            </Col>
            <Col>
              <Button
                style={{
                  background: "none",
                  color: "#fff",
                  border: "2px solid #fff",
                }}
                onClick={handleSearchReset}
              >
                Reset
              </Button>
            </Col>
          </Row>
        </Form>
        <Button
          style={{
            background: "none",
            color: "#fff",
            border: "2px solid #fff",
          }}
          onClick={() => setRefreshData(true)}
        >
          <MdOutlineRefresh className="fs-4" /> Refresh
        </Button>
      </div>
      <Table hover responsive>
        <thead className="align-top">
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            {/* <th>Pickup Location</th> */}
            {/* <th>Dropoff Location</th> */}
            {/* <th>Date</th> */}
            {/* <th>Time</th> */}
            {/* <th>Vehicle</th> */}
            <th>Action</th>
          </tr>
        </thead>
        <tbody className="table-group-divider">
          {quotations && quotations.length > 0 ? (
            quotations.map((quotation, index) => (
              <tr key={quotation._id}>
                <td>{(page - 1) * limit + index + 1}</td>
                <td>{quotation.fullName}</td>
                <td>{quotation.email}</td>
                <td>{quotation.phone}</td>
                {/* <td>{quotation.pickUpLocation}</td> */}
                {/* <td>{quotation.dropOffLocation}</td> */}
                {/* <td>{quotation.pickUpDate}</td> */}
                {/* <td>{quotation.pickUpTime}</td> */}
                {/* <td>{quotation.vehicleName}</td> */}
                <td>
                  <Button
                    color="dark"
                    onClick={() => navigate(`/quotations/${quotation._id}`)}
                  >
                    View Details
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10" className="text-center fs-3 text-danger">
                No Quotations Available!
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      
      {/* Pagination */}
      {totalPages > 1 && (
        <Pagination
          aria-label="Page navigation"
          className="d-flex justify-content-center align-items-center"
        >
          <PaginationItem className="p-2" disabled={page <= 1}>
            <PaginationLink
              style={{
                background: "transparent",
                color: "#fff",
                border: "2px solid #b88d48",
                borderRadius: "25%",
              }}
              previous
              onClick={() => handlePageChange(page - 1)}
            />
          </PaginationItem>

          {Array.from(
            { length: endPage - startPage + 1 },
            (_, index) => startPage + index
          ).map((pageNumber) => (
            <PaginationItem
              className="p-2"
              active={page === pageNumber}
              key={pageNumber}
            >
              <PaginationLink
                style={{
                  background: "transparent",
                  color: "#fff",
                  border: "2px solid #b88d48",
                  borderRadius: "25%",
                }}
                onClick={() => handlePageChange(pageNumber)}
              >
                {pageNumber}
              </PaginationLink>
            </PaginationItem>
          ))}

          <PaginationItem className="p-2" disabled={page >= totalPages}>
            <PaginationLink
              style={{
                background: "transparent",
                color: "#fff",
                border: "2px solid #b88d48",
                borderRadius: "25%",
              }}
              next
              onClick={() => handlePageChange(page + 1)}
            />
          </PaginationItem>
        </Pagination>
      )}
    </div>
  );
};

export default Quotations; 